import React, { useState } from "react"

import { Arrow } from "components/page-components/Icons/small"
import { Link } from "gatsby"
import { PlacesOfDeliveryList } from "components/page-components/Ausschreibungsdienste/landingpage-components"

export const InternalSearchNoticeHit = ({
  hit,
  location,
  close_search_modal,
}) => {
  const {
    places_of_delivery_struct,
    RefIDStringBI,
    ScopeOfServices,
    ServiceTypeName,
    TitelOnline,
    ZoneOfRequestName,
  } = hit

  const [scopeOfServicesOpen, setScopeOfServicesOpen] = useState(false)

  const has_scope_of_servces = ScopeOfServices !== ""

  const openModal = () => {
    setScopeOfServicesOpen(true)
  }
  const closeModal = () => {
    setScopeOfServicesOpen(false)
  }

  return (
    <div
      className="columns is-gapless is-mobile has-text-white p-5 is-clipped"
      style={{ border: "1px solid #FFF", height: "100%" }}
    >
      <div
        className="column is-12 is-clipped is-flex is-flex-direction-column"
        style={{
          hight: "100%",
          minHeight: 250,
          transition: "all .3s ease",
          transform: scopeOfServicesOpen
            ? "translateX(-110%)"
            : "translateX(0%)",
        }}
      >
        <p className="mb-auto">
          {ServiceTypeName} | {ZoneOfRequestName}
        </p>
        <Link
          onClick={close_search_modal}
          to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
          className={`title is-4 mb-3 has-text-white`}
        >
          {TitelOnline}
        </Link>

        <div className="my-auto">
          <div className={`has-text-weight-bold has-text-white`}>
            Ausführungsort
            {places_of_delivery_struct.length > 1 ? "e" : null}:
          </div>
          <PlacesOfDeliveryList
            {...{
              is_internal_search: true,
              places_of_delivery_struct,
              initial_list_length: 2,
              location,
            }}
          />
        </div>

        <div className="columns mb-0 mt-auto">
          <div className="column is-half py-1 pl-0 px-0-mobile">
            {has_scope_of_servces ? (
              <button
                onClick={openModal}
                className={`button is-fullwidth has-text-weight-bold is-white-20`}
              >
                Leistungsbeschreibung
              </button>
            ) : null}
          </div>
          <div className="column is-half py-1 pr-0 px-0-mobile">
            <Link
              to={`/ausschreibungsdienste/ausschreibungen/${RefIDStringBI}`}
              className={`button is-fullwidth  is-tertiary `}
            >
              Bekanntmachung öffnen
            </Link>
          </div>
        </div>
      </div>

      {has_scope_of_servces ? (
        <div
          className="has-text-white column is-12"
          style={{
            transition: "all .3s ease",
            transform: scopeOfServicesOpen
              ? "translateX(-100%)"
              : "translateX(10%)",
          }}
        >
          <div className="level is-mobile mb-2">
            <div className="level-left">
              <div
                onKeyPress={() => {}}
                role="button"
                tabIndex="-1"
                aria-label="go back"
                className="level-item has-text-white is-clickable"
                onClick={closeModal}
              >
                <Arrow
                  {...{ direction: "left", color: "#FFFFFF", size: 0.7 }}
                />

                <div className="level-item ml-3">
                  <p className="title is-6 has-text-white">
                    Leistungsbeschreibung:
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="mt-3 internal-scope-of-services"
            dangerouslySetInnerHTML={{ __html: ScopeOfServices }}
          ></div>
        </div>
      ) : null}
    </div>
  )
}
